"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GridElement;

(function (GridElement) {
  GridElement["grid"] = "grid";
  GridElement["row"] = "row";
  GridElement["column"] = "column";
  GridElement["component"] = "component";
})(GridElement = exports.GridElement || (exports.GridElement = {}));